var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniversityTution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 10.7501V4.2876C15.75 3.6251 15.4875 2.9876 15.0125 2.5251L12.875 0.387598C12.3875 -0.0999023 11.6 -0.0999023 11.1125 0.387598L8.9875 2.5126C8.5125 2.9876 8.25 3.6251 8.25 4.2876V5.7501H3.25C1.875 5.7501 0.75 6.8751 0.75 8.2501V20.7501C0.75 22.1251 1.875 23.2501 3.25 23.2501H20.75C22.125 23.2501 23.25 22.1251 23.25 20.7501V13.2501C23.25 11.8751 22.125 10.7501 20.75 10.7501H15.75ZM5.75 20.7501H3.25V18.2501H5.75V20.7501ZM5.75 15.7501H3.25V13.2501H5.75V15.7501ZM5.75 10.7501H3.25V8.2501H5.75V10.7501ZM13.25 20.7501H10.75V18.2501H13.25V20.7501ZM13.25 15.7501H10.75V13.2501H13.25V15.7501ZM13.25 10.7501H10.75V8.2501H13.25V10.7501ZM13.25 5.7501H10.75V3.2501H13.25V5.7501ZM20.75 20.7501H18.25V18.2501H20.75V20.7501ZM20.75 15.7501H18.25V13.2501H20.75V15.7501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityTution);
export default __webpack_public_path__ + "static/media/university_tution.000623d71999f97c0885e3b54a1af035.svg";
export { ForwardRef as ReactComponent };